<template>
    <section class="signup-section spad set-bg">
        <div class="signup-warp d-flex">
            <!-- signup form -->
            <div class="signup-container ml-auto mr-auto mt-sm-5">
            <!-- signup form -->
                <form v-if="!success" class="signup-form m-3 m-sm-0 pt-5" v-on:submit.prevent="recover">
                    <p class="h2 mb-4">Recuperar contraseña</p>
                    <h6 class="text-left mb-3">Introduce tu correo electrónico y te enviaremos un email con las instrucciones para reestablecer tu contraseña:</h6>
                    <input type="email" name="correo" id="correo" :class="{'margin-zero': errors.has('correo')}" placeholder="Correo electrónico" v-model="email" v-validate="'required'">
                    <p class="form-error" v-show="errors.has('correo')">{{ errors.first('correo') }}</p>
                    <vue-recaptcha id="captcha" sitekey="6LfCJuIZAAAAALtujhJ0zzJ5_Jn6RuzIjtfJaRWz" :loadRecaptchaScript="true" @verify="isVerified = true" @expired="isVerified = false"></vue-recaptcha>
                    <input type="submit" value="Enviar correo de recuperacion" class="site-btn" v-if="!loading" :disabled="!isVerified">
                    <div class="loader-container" v-else>
                        <div class="loader"></div>
                    </div>
                    <p class="api-error" v-if ="errorMsg">{{errorMsg}}</p>	
                </form>
                <form v-else class="signup-form signup-form m-3 m-sm-0 pt-5">
                    <p class="h2 mb-4">Recuperar contraseña</p>
                    <h6 class="text-left mb-3">Se ha enviado un correo a <b>{{ email }}</b> con las instrucciones para reestablecer tu contraseña.</h6>
                    <button class="site-btn" @click="success = false">Reenviar correo</button>			
                </form>
            </div>
        </div>
	</section>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import messagesEs from 'vee-validate/dist/locale/es.js';
import VueRecaptcha from 'vue-recaptcha';

import { API_URL } from '@/config.js'

Vue.use(VeeValidate, {
    locale: 'es',
    events: 'blur',
    dictionary: {
        es: messagesEs
    }
});

Validator.localize('es', { 
    custom: {
        correo: {
            email: 'Debes introducir un correo electrónico válido',
            required: 'Debes introducir tu correo electrónico'
        },
        password: {
            required: 'Debes introducir tu contraseña'
        },
        repeatPassword: {
            required: 'Debes introducir de nuevo la contraseña'
        }
    }
});

export default {
    name: 'register',
    components: { VueRecaptcha },
    data() {
        return {
            email: null,
            errorMsg: null,
            loading: false,
            success: false,
            isVerified: false
        }
    },
    methods: {
        recover() {
            this.loading = true;
            this.errorMsg = null;
            this.$validator.validate().then(valid => {
                if (valid) {
                    axios.post(`${API_URL}/public/user/recover`, {
                        email: this.email
                    })
                        .then(response => {
                            this.loading = false;
                            if (response.status == 200) {
                                this.success = true;
                                this.errorMsg = null;
                            } else {
                                this.errorMsg = "Se ha producido un error al enviar el email de recuperación de contraseña. Inténtalo de nuevo en unos minutos.";
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.errorMsg = "Se ha producido un error al enviar el email de recuperación de contraseña. Inténtalo de nuevo en unos minutos.";
                        });
                } else {
                    this.loading = false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/variables.scss";

    .signup-section {
        min-height: calc(100vh - 48px);
        padding-top: $header-unauth-height;
        background-color: $main-color-brown;
        background-image: url("https://www.justcompileit.com/videos/cursos-streaming/images/register.jpg");
        .signup-container {
            width: 100vw;
            max-width: 700px;
            box-sizing: border-box;
        }
        .signup-form {
            input[type=password] {
                height: 57px;
                width: 100%;
                padding: 0 30px;
                margin-bottom: 27px;
                float: left;
                border: none;
                font-size: 14px;
                font-weight: 500;
                background: #edf4f6;
            }
            input.margin-zero {
                margin-bottom: 4px;
                background-color:#ffdfdf;
            }
            .form-error {
                display: inherit;
                text-align: left;
                color: red;
                margin-left: 10px;
                margin-bottom: 8px;
                line-height: 16px;
            }
            .api-error {
                color: red;
                margin: 15px 10px -10px;
                font-size: 16px;
                line-height: 22px;
            }
            .recover-link {
                font-size: 16px;
                margin-top: 25px;
                margin-bottom: 0;
            }
            #captcha {
                display: table;
                margin: auto;
                margin-bottom: 20px;
            }
        }
    }
</style>

